import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import {Capacitor, registerPlugin} from "@capacitor/core";

import en from "./locales/en.json";
import de from "./locales/de.json";
import it from "./locales/it.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";

const SUPPORTED_LANGUAGES = ["en", "de", "it", "fr", "es"];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {translation: en},
      de: {translation: de},
      it: {translation: it},
      fr: {translation: fr},
      es: {translation: es}
    },
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ["localStorage", "navigator"],
      cacheUserLanguage: true
    }
  } as any);

// On Android, always sync the web language to the OS locale, overriding any
// value that i18next may have auto-cached in localStorage from a previous session.
if (Capacitor.getPlatform() === "android") {
  const UserContextPlugin = registerPlugin<any>("UserContextPlugin");
  UserContextPlugin.getDeviceLocale()
    .then(({language}) => {
      const lang = SUPPORTED_LANGUAGES.includes(language) ? language : "en";
      localStorage.removeItem("i18nextLng");
      i18n.changeLanguage(lang);
    })
    .catch(() => {
      // Silently fall back to whatever the detector already chose
    });
}

export default i18n;
